export interface Event<TKey extends string = string, T = unknown, TMeta = unknown> {
  name: TKey;
  payload: T;
  meta?: TMeta;
}

export function createEvent<TKey extends string, T>(name: TKey, payload: T): Event<TKey, T> {
  return {
    name,
    payload
  };
}
